import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionDetailAnscNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';

const RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusShared
        items={CivilUnionDetailAnscNotificationsNonResidentCancellationsCrumbs()}
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage.displayName =
  'Research CivilUnion Detail Notifications Page component';

export default RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage;
